import React, { Component } from 'react';
//import {Link} from 'react-router-dom';
import { connect } from 'react-redux';
//import Card from 'react-bootstrap/Card';
//import Nav from 'react-bootstrap/Nav';
import {
    Table,
    Text,
    keys,
    Group,
    UnstyledButton,
    rem,
    Center,
    Divider,
    Flex,
    Collapse,
    Timeline,
    Space,
    Loader,
    Select,
    Paper
} from '@mantine/core';
import dayjs from 'dayjs';

import classes from '../TableSort.module.css';
import { IconSelector, IconChevronDown, IconChevronUp, IconLineDashed } from '@tabler/icons-react';
import HardwareTicketDataService from '../../services/hardware-ticket-activities';
import HoldingTableDataService from '../../services/holding-table-activities';

import AssignTechsTicketsCalendarService from '../../services/assign-techs_tickets-calendar-activities';

import { REPORT_TENANT_CHANGE_RESOLVED } from '../../features/actions/Is-Logged-Actions';
import { 
    REPORT_RESOLVED_TIMESPAN_CHANGE_RESOLVED, 
    REPORT_TIMESPAN_TYPE_CHANGE_RESOLVED, 
    REPORT_ASSIGNED_TO_CHANGE_RESOLVED, 
    UPDATE_RESOLVED_TICKET_REPORT_OPEN_STATUS,
    UPDATE_RESOLVED_SORTING
} from '../../features/actions/Reports-Actions';

import { DatePickerInput } from '@mantine/dates';
import { store } from '../../app/store';


function Th(props) {
    const Icon = props.sorted ? (props.reversed ? IconChevronUp : IconChevronDown) : IconSelector;
    return (
        <Table.Th className={classes.th}>
            <UnstyledButton onClick={props.onSort} className={classes.timespanReportControl}>
                <Group justify="left"/* justify="space-between" */>
                    <Text fw={800} fz="sm">
                        {props.children}
                    </Text>
                    <Center className={classes.icon}>
                        <Icon style={{ width: rem(16), height: rem(16) }} stroke={1.5} />
                    </Center>
                </Group>
            </UnstyledButton>
        </Table.Th>
    );
}

class ResolvedTickets extends Component {
    constructor(props) {
        super(props);

        this.state = {
            resolvedTickets: [],
            itemCount: 0,
            showLoader: false,
            hasRun: false,       // prevents the get data code from running more than once after global state change detected
            sortBy: "id",
            sortOrder: "ASC"
        }
    }

    componentDidMount() {
        this.setState({
            sortBy: this.props.reportInfo.resolved_sort_by,
            sortOrder: this.props.reportInfo.resolved_sort_order
        }, () => {
            this.getResolvedTickets();
        });
        
    }


    componentDidUpdate(prevProps) {
        if (this.props.loggedStatus.report_tenant_change_detected && !prevProps.loggedStatus.report_tenant_change_detected) {
            this.props.REPORT_TENANT_CHANGE_RESOLVED();

            // get the new list of resolved tickets
            this.getResolvedTickets();
        }

        if(this.props.reportInfo.report_resolved_timespan_change_detected || this.props.reportInfo.report_timespan_type_change_detected || this.props.reportInfo.report_assigned_to_change_detected) {
            if(this.props.reportInfo.report_resolved_timespan_change_detected && !prevProps.reportInfo.report_resolved_timespan_change_detected) {
                this.props.REPORT_RESOLVED_TIMESPAN_CHANGE_RESOLVED();
                console.log("resolved timespan change detected in child 3");

                this.getResolvedTickets();
            }

            // we don't need to worry about fetching on type change because this table will only show Resolved tickets

            // else if(this.props.reportInfo.report_timespan_type_change_detected && !prevProps.reportInfo.report_timespan_type_change_detected) {
            //     this.props.REPORT_TIMESPAN_TYPE_CHANGE_RESOLVED();
            //     console.log("timespan type change detected in child 3");

            //     this.getResolvedTickets();
            // }

            else if(this.props.reportInfo.report_assigned_to_change_detected && !prevProps.reportInfo.report_assigned_to_change_detected) {
                this.props.REPORT_ASSIGNED_TO_CHANGE_RESOLVED();
                console.log("timespan assigned to change detected in child 3");

                this.getResolvedTickets();
            }
        }
    }

    // use the global state value for the selected tenant from the report component to get the necessary resolved ticket info
    getResolvedTickets() {
        this.setState({
            showLoader: true
        });

        console.log("I'm in getResolvedTickets, value of timespan in state is: ", this.props.reportInfo.resolved_timespan);

        if(this.props.reportInfo.resolved_timespan && this.props.reportInfo.timespanAssignedToArray && this.props.reportInfo.resolved_timespan.length > 1) {
            var timespan = [this.props.reportInfo.resolved_timespan[0] ? dayjs(Date.parse(this.props.reportInfo.resolved_timespan[0])).$d : null, this.props.reportInfo.resolved_timespan[1] ? dayjs(Date.parse(this.props.reportInfo.resolved_timespan[1])).$d : null]

            console.log("Timespan in getResolvedTickets: ", timespan);
            // generate the list of id numbers user has requested in the filter drop down
            let requesterIdList = [];

            for(let r = 0; r < this.props.reportInfo.timespanAssignedToArray.length; r++) {
                requesterIdList.push(this.props.reportInfo.timespanAssignedToArray[r].value);
            }

            console.log("List of ids to send: ", requesterIdList);

            
            // hardcoding Resolved because that is the only type of ticket this widget is concerned with at all times
            HardwareTicketDataService.getResolvedTickets(this.props.loggedStatus.report_tenant_id_selected, timespan, "Resolved", requesterIdList, this.props.loggedStatus.id, this.props.loggedStatus.timezone_adjustment_factor)
            .then(response => {
                console.log("Resolved ticket list returned: ", response);
                this.setState({
                    resolvedTickets: response.data.results,
                    itemCount: response.data.rowCount,
                    showLoader: false
                }, () => this.sortTable(this.state.resolvedTickets, this.state.sortBy, this.state.sortOrder));
            })
            .catch(e => {
                console.log(e);
            });
        }
    }

    goToHardwareTicketDetails(id) {
        this.props.history.push(`/hardwareTickets/${id}`);
    }

    goToHoldingTicketDetails(id) {
        this.props.history.push(`/clarifyTicket/${id}`);
    }

    handleReportOpenChange() {
        this.props.UPDATE_RESOLVED_TICKET_REPORT_OPEN_STATUS();     // toggles global state value between true and false
    }

    // locally sorts the data displayed in the table based on the column clicked and sort order
    // affects resolvedTickets []
    sortTable(array, sortBy, sortOrder) {
        const sortedArray = [...array].sort((a, b) => {
            let aVal = a[sortBy];
            let bVal = b[sortBy];
        
            // Treat null or undefined assigned_tech_name as "Unassigned"
            if (sortBy === "assigned_tech_name") {
              aVal = aVal ?? "Unassigned";
              bVal = bVal ?? "Unassigned";
            }
        
            // For string comparison (case-insensitive)
            if (typeof aVal === "string" && typeof bVal === "string") {
              const result = aVal.toLowerCase().localeCompare(bVal.toLowerCase());
              return sortOrder === "ASC" ? result : -result;
            }
        
            // For number or date comparison
            if (aVal > bVal) return sortOrder === "ASC" ? 1 : -1;
            if (aVal < bVal) return sortOrder === "ASC" ? -1 : 1;
            return 0;
        });

        console.log("here is the sorted array: ", sortedArray);
        
        //return sortedArray;
        this.setState({
            resolvedTickets: sortedArray
        });
    }

    // fired when user clicks a table header - sorts resolved tickets by column and flips sort order
    handleSortByAndOrderChange(new_column_name) {

        let newSortOrder;
        if(this.state.sortOrder === "ASC") {
            newSortOrder = "DESC";
        }

        else {
            newSortOrder = "ASC";
        }

        // if this is a new column, change both the column sorted and the order
        if(new_column_name !== this.state.sortBy) {
            this.setState({
                sortBy: new_column_name,
                sortOrder: newSortOrder,
                //offset: 0
            }, () => this.sortTable(this.state.resolvedTickets, new_column_name, newSortOrder));
        }

        // otherwise it was the same column, so just change the sort order
        else {
            this.setState({
                sortOrder: newSortOrder,
                //offset: 0
            }, () => this.sortTable(this.state.resolvedTickets, this.state.sortBy, newSortOrder));
        }

        // update global state for sortBy and sortOrder here
        this.props.UPDATE_RESOLVED_SORTING({sortBy: new_column_name});
    }


    render() {

        // technically, resolved tickets will only contain a source of "Hardware" - an unclarified ticket can not be solved
        const rows = this.state.resolvedTickets.map((ticket) => {
            if (ticket.source === "Hardware") {
                return <Table.Tr key={`hardware_${ticket.id}`} onClick={(event) => {event.stopPropagation(); this.goToHardwareTicketDetails(ticket.id)}}>
                    <Table.Td w="14%">{`# ${ticket.id}`}</Table.Td>
                    <Table.Td w="14%">{ticket.sla_name ? ticket.sla_name : "Not Yet Set"}</Table.Td>
                    <Table.Td w="16%">{ticket.asker_name}</Table.Td>
                    <Table.Td w="16%">{ticket.assigned_tech_name ? ticket.assigned_tech_name : "Unassigned"}</Table.Td>
                    <Table.Td w="10%">{ticket.formatted_date_time_created}</Table.Td>
                    <Table.Td w="10%">{ticket.formatted_date_time_resolved}</Table.Td>
                    <Table.Td w="20%">{ticket.ticket_title}</Table.Td>
                </Table.Tr>
            }

            else {
                return <Table.Tr key={`unclarified_${ticket.id}`} onClick={(event) => {event.stopPropagation(); this.goToHoldingTicketDetails(ticket.id)}}>
                    <Table.Td w="14%">{`Temp# ${ticket.id}`}</Table.Td>
                    <Table.Td w="14%">{ticket.sla_name ? ticket.sla_name : "Not Yet Set"}</Table.Td>
                    <Table.Td w="16%">{ticket.asker_name}</Table.Td>
                    <Table.Td w="16%">{ticket.assigned_tech_name ? ticket.assigned_tech_name : "Unassigned"}</Table.Td>
                    <Table.Td w="10%">{ticket.formatted_date_time_created}</Table.Td>
                    <Table.Td w="10%">{ticket.formatted_date_time_resolved}</Table.Td>
                    <Table.Td w="20%">{ticket.ticket_title}</Table.Td>
                </Table.Tr>
            }
        })

        return (
            <>
                <Paper withBorder p="md" radius="md" display="block" m="5px" onClick={() => this.handleReportOpenChange()}>
                    {this.state.showLoader === true ? 
                        <div><Text size="xl" fw={700} component="span">{`Resolved Tickets ( `}</Text><span style={{ display: 'inline-flex', alignItems: 'center' }}><Loader type="dots" color="green"/></span><Text size="xl" fw={700} component="span">{` )`}</Text>{this.props.reportInfo.resolved_ticket_report_open ? <IconChevronDown style={{marginLeft: "10px"}}/> : <IconChevronUp style={{marginLeft: "10px"}}/>}</div>
                        :
                        <div><Text size="xl" fw={700} component="span">{`Resolved Tickets ( `}</Text><Text size="xl" fw={700} component="span" c="green">{`${this.state.itemCount}`}</Text><Text size="xl" fw={700} component="span">{` )`}</Text>{this.props.reportInfo.resolved_ticket_report_open ? <IconChevronDown style={{marginLeft: "10px"}}/> : <IconChevronUp style={{marginLeft: "10px"}}/>}</div>
                    }
                    <Collapse in={this.props.reportInfo.resolved_ticket_report_open}>
                        <Table highlightOnHover="true" style={{ cursor: "pointer" }}>
                            <Table.Thead>
                                <Table.Tr>
                                    <Th 
                                        w="14%"
                                        sorted={this.state.sortBy === 'id'}
                                        reversed={this.state.sortOrder === "ASC"}
                                        onSort={(event) => {event.stopPropagation(); this.handleSortByAndOrderChange("id")}}
                                        style={{cursor: "pointer"}}
                                    >
                                        <div className={this.state.sortBy === "id" ? "activeMyAssignedTicketsHeader" : ""}>ID</div>
                                    </Th>
                                    <Th 
                                        w="14%"
                                        sorted={this.state.sortBy === 'sla_name'}
                                        reversed={this.state.sortOrder === "ASC"}
                                        onSort={(event) => {event.stopPropagation(); this.handleSortByAndOrderChange("sla_name")}}
                                        style={{cursor: "pointer"}}
                                    >
                                        <div className={this.state.sortBy === "sla_name" ? "activeMyAssignedTicketsHeader" : ""}>Priority</div>
                                    </Th>
                                    <Th 
                                        w="16%"
                                        sorted={this.state.sortBy === 'asker_name'}
                                        reversed={this.state.sortOrder === "ASC"}
                                        onSort={(event) => {event.stopPropagation(); this.handleSortByAndOrderChange("asker_name")}}
                                        style={{cursor: "pointer"}}
                                    >
                                        <div className={this.state.sortBy === "asker_name" ? "activeMyAssignedTicketsHeader" : ""}>Requester</div>
                                    </Th>
                                    <Th 
                                        w="16%"
                                        sorted={this.state.sortBy === 'assigned_tech_name'}
                                        reversed={this.state.sortOrder === "ASC"}
                                        onSort={(event) => {event.stopPropagation(); this.handleSortByAndOrderChange("assigned_tech_name")}}
                                        style={{cursor: "pointer"}}
                                    >
                                        <div className={this.state.sortBy === "assigned_tech_name" ? "activeMyAssignedTicketsHeader" : ""}>Assigned To</div>
                                    </Th>
                                    <Th 
                                        w="10%"
                                        sorted={this.state.sortBy === 'formatted_date_time_created'}
                                        reversed={this.state.sortOrder === "ASC"}
                                        onSort={(event) => {event.stopPropagation(); this.handleSortByAndOrderChange("formatted_date_time_created")}}
                                        style={{cursor: "pointer"}}
                                    >
                                        <div className={this.state.sortBy === "formatted_date_time_created" ? "activeMyAssignedTicketsHeader" : ""}>Time Created</div>
                                    </Th>
                                    <Th
                                        w="10%"
                                        sorted={this.state.sortBy === 'formatted_date_time_resolved'}
                                        reversed={this.state.sortOrder === "ASC"}
                                        onSort={(event) => {event.stopPropagation(); this.handleSortByAndOrderChange("formatted_date_time_resolved")}}
                                        style={{cursor: "pointer"}}
                                    >
                                        <div className={this.state.sortBy === "formatted_date_time_resolved" ? "activeMyAssignedTicketsHeader" : ""}>Time Resolved</div>
                                    </Th>
                                    <Th
                                        w="20%"
                                        sorted={this.state.sortBy === 'ticket_title'}
                                        reversed={this.state.sortOrder === "ASC"}
                                        onSort={(event) => {event.stopPropagation(); this.handleSortByAndOrderChange("ticket_title")}}
                                        style={{cursor: "pointer"}}
                                    >
                                        <div className={this.state.sortBy === "ticket_title" ? "activeMyAssignedTicketsHeader" : ""}>Title</div>
                                    </Th>
                                </Table.Tr>
                            </Table.Thead>
                        {/* </Table> */}
                        {/* <Table highlightOnHover="true" style={{ cursor: "pointer" }}> */}
                        {this.props.reportInfo.resolved_ticket_report_open ? 
                            <Table.Tbody>
                                {rows && rows.length > 0 ? (
                                    rows
                                ) : (
                                    <Table.Tr>
                                        <Table.Td colSpan={7}>
                                            <Text fw={500} ta="center">
                                                Nothing found
                                            </Text>
                                        </Table.Td>
                                    </Table.Tr>
                                )}
                            </Table.Tbody>
                            :
                            undefined
                        }
                        </Table>
                    </Collapse>
                </Paper>
            </>
        )
    }
}


const mapStateToProps = (state) => {
    return {
        loggedStatus: state.logged,
        activeNavLinkStatus: state.activeNav,    // Use global state to control which link is highlighted
        reportInfo: state.reports
    };
}

export default connect(mapStateToProps, { REPORT_TENANT_CHANGE_RESOLVED, REPORT_RESOLVED_TIMESPAN_CHANGE_RESOLVED, REPORT_TIMESPAN_TYPE_CHANGE_RESOLVED, REPORT_ASSIGNED_TO_CHANGE_RESOLVED, UPDATE_RESOLVED_TICKET_REPORT_OPEN_STATUS, UPDATE_RESOLVED_SORTING })(ResolvedTickets);